module.exports = __webpack_public_path__ + "static/media/md-flask.e43b1120.svg";